<template>
  <a
    @click="copyLink()"
  >
    {{ t("copy_link") }}
    <i class="material-icons vertical-middle">
      link
    </i>
  </a>
</template>


<script>
import "../i18n/ja";
import { i18n } from "../mixins/i18n";

export default {
  mixins: [i18n],
  props: {
    pagePath: {
      type: String,
      required: true
    }
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.pagePath);
      $(".copylink").removeClass("d-none");
      $(".copylink").css("display", "");

      setTimeout(() => {
        $(".copylink").fadeOut(500);
      }
      , 3000);
    }
  }
};
</script>
